import React from 'react'
import IllustrationWrapper from '../../Illustrration/IllustrationWrapper'
import DataLostSvg from '../../Illustrration/components/DataLostSvg'
import DisclaimerSvg from '../../Illustrration/components/DisclaimerSvg'

const NoAccess = () => {
  return (
    <IllustrationWrapper 
        illustration={<DisclaimerSvg />}
        title="Access Denied!"
        subtitle="Please select a different SAP code to enable and use this feature. "
    />
  )
}

export default NoAccess